/**
 * Landing content — features & FAQ in 5 lingue (IT, EN, FR, DE, ES).
 * Ogni entry ha una forma: { title: { it, en, fr, de, es }, desc: { ... } }.
 * Il rendering viene fatto in LandingPage.jsx con `entry.title[lang] || entry.title.it`.
 */

// ═══════════════════════════════════════════════════════════════
// SITO WEB — Feature Grid (20 card)
// ═══════════════════════════════════════════════════════════════
export const siteFeatures = [
  {
    key: "voice",
    color: "#dc2626",
    badge: { it: "NEW", en: "NEW", fr: "NEW", de: "NEU", es: "NEW" },
    title: { it: "Voci della Casa", en: "Voices of the House", fr: "Voix de la Maison", de: "Stimmen des Hauses", es: "Voces de la Casa" },
    desc: {
      it: "Audiorecensioni vocali degli ospiti: un saluto di un minuto, pubblichi solo ciò che approvi.",
      en: "Guest voice reviews: a one-minute greeting, you publish only what you approve.",
      fr: "Avis vocaux des invités : un message d'une minute, vous ne publiez que ce que vous approuvez.",
      de: "Sprach-Reviews der Gäste: ein einminütiger Gruß, du veröffentlichst nur, was du freigibst.",
      es: "Audioreseñas de los huéspedes: un saludo de un minuto, publicas solo lo que apruebas.",
    },
  },
  {
    key: "pwa_install",
    color: "#7C3AED",
    badge: { it: "NEW", en: "NEW", fr: "NEW", de: "NEU", es: "NEW" },
    title: { it: "Web App + Notifiche", en: "Installable Web App", fr: "Web App + Notifications", de: "Web App + Push", es: "Web App + Notificaciones" },
    desc: {
      it: "Gli ospiti installano la pagina della casa come una vera app sulla Home del telefono e ricevono le tue notifiche push: offerte, date libere, novità.",
      en: "Guests install the property page as a real app on their phone's Home and receive your push notifications: offers, free dates, news.",
      fr: "Les invités installent la page du logement comme une vraie app sur l'écran d'accueil et reçoivent vos notifications push : offres, dates libres, nouveautés.",
      de: "Gäste installieren die Objektseite als echte App auf dem Home-Bildschirm und erhalten deine Push-Nachrichten: Angebote, freie Termine, News.",
      es: "Los huéspedes instalan la página de la casa como una app real en la pantalla de inicio y reciben tus notificaciones push: ofertas, fechas libres, novedades.",
    },
  },
  {
    key: "landing_premium",
    color: "#d04260",
    title: { it: "Landing premium", en: "Premium landing", fr: "Landing premium", de: "Premium-Landing", es: "Landing premium" },
    desc: {
      it: "Cover gallery, host card, mappa. Stile Airbnb, zero template.",
      en: "Cover gallery, host card, map. Airbnb-style, zero templates.",
      fr: "Galerie de couverture, carte hôte, carte. Style Airbnb, zéro template.",
      de: "Cover-Galerie, Host-Karte, Karte. Airbnb-Style, keine Templates.",
      es: "Galería, tarjeta host, mapa. Estilo Airbnb, sin plantillas.",
    },
  },
  {
    key: "foto_video",
    color: "#A855F7",
    title: { it: "Foto & Video", en: "Photos & Video", fr: "Photos & Vidéo", de: "Fotos & Video", es: "Fotos y Vídeo" },
    desc: {
      it: "Gallery ordinabile drag&drop + video YouTube integrato.",
      en: "Drag&drop sortable gallery + embedded YouTube video.",
      fr: "Galerie triable en glisser-déposer + vidéo YouTube intégrée.",
      de: "Sortierbare Drag&Drop-Galerie + eingebettetes YouTube-Video.",
      es: "Galería reordenable drag&drop + vídeo YouTube integrado.",
    },
  },
  {
    key: "ical",
    color: "#2563EB",
    title: { it: "Calendario iCal", en: "iCal Calendar", fr: "Calendrier iCal", de: "iCal-Kalender", es: "Calendario iCal" },
    desc: {
      it: "Sync Airbnb · Booking · VRBO ogni 30 min. No overbooking.",
      en: "Sync Airbnb · Booking · VRBO every 30 min. No overbooking.",
      fr: "Sync Airbnb · Booking · VRBO toutes les 30 min. Pas de surréservation.",
      de: "Sync Airbnb · Booking · VRBO alle 30 Min. Kein Overbooking.",
      es: "Sync Airbnb · Booking · VRBO cada 30 min. Sin overbooking.",
    },
  },
  {
    key: "booking_engine",
    color: "#10B981",
    title: { it: "Booking Engine", en: "Booking Engine", fr: "Moteur de résa", de: "Buchungs-Engine", es: "Motor de reservas" },
    desc: {
      it: "Smoobu, Lodgify, Slope, Octorate, Guesty, Hospitable.",
      en: "Smoobu, Lodgify, Slope, Octorate, Guesty, Hospitable.",
      fr: "Smoobu, Lodgify, Slope, Octorate, Guesty, Hospitable.",
      de: "Smoobu, Lodgify, Slope, Octorate, Guesty, Hospitable.",
      es: "Smoobu, Lodgify, Slope, Octorate, Guesty, Hospitable.",
    },
  },
  {
    key: "mappa",
    color: "#0EA5E9",
    title: { it: "Mappa & Indirizzo", en: "Map & Address", fr: "Carte & Adresse", de: "Karte & Adresse", es: "Mapa y Dirección" },
    desc: {
      it: "Geocoding auto, Google Maps, raggiungibilità.",
      en: "Auto geocoding, Google Maps, transit info.",
      fr: "Géocodage auto, Google Maps, accessibilité.",
      de: "Auto-Geocoding, Google Maps, Erreichbarkeit.",
      es: "Geocodificación auto, Google Maps, accesibilidad.",
    },
  },
  {
    key: "meteo",
    color: "#F59E0B",
    title: { it: "Meteo Live", en: "Live Weather", fr: "Météo Live", de: "Live-Wetter", es: "Tiempo Live" },
    desc: {
      it: "Previsioni 7 giorni per gli ospiti indecisi.",
      en: "7-day forecast for undecided guests.",
      fr: "Prévisions à 7 jours pour les hôtes hésitants.",
      de: "7-Tage-Vorhersage für unentschlossene Gäste.",
      es: "Previsiones a 7 días para huéspedes indecisos.",
    },
  },
  {
    key: "google_reviews",
    color: "#FBBF24",
    title: { it: "Recensioni Google", en: "Google Reviews", fr: "Avis Google", de: "Google-Bewertungen", es: "Reseñas Google" },
    desc: {
      it: "Import automatico ogni 7 giorni con stelle e data.",
      en: "Auto import every 7 days with stars and date.",
      fr: "Import automatique tous les 7 jours avec étoiles et date.",
      de: "Auto-Import alle 7 Tage mit Sternen und Datum.",
      es: "Importación automática cada 7 días con estrellas y fecha.",
    },
  },
  {
    key: "blog",
    color: "#A855F7",
    title: { it: "Blog Struttura", en: "Property Blog", fr: "Blog de la propriété", de: "Unterkunfts-Blog", es: "Blog del alojamiento" },
    desc: {
      it: "Articoli sulla zona indicizzati su Google.",
      en: "Local area articles indexed on Google.",
      fr: "Articles sur la zone indexés sur Google.",
      de: "Artikel über die Umgebung, indiziert bei Google.",
      es: "Artículos sobre la zona indexados en Google.",
    },
  },
  {
    key: "servizi_extra",
    color: "#EC4899",
    title: { it: "Servizi Extra", en: "Extra Services", fr: "Services Extras", de: "Extra-Services", es: "Servicios Extra" },
    desc: {
      it: "Late check-out, colazione, transfer, bici. Monetizza.",
      en: "Late check-out, breakfast, transfer, bikes. Monetize.",
      fr: "Late check-out, petit-dej, transfert, vélos. Monétisez.",
      de: "Late Check-out, Frühstück, Transfer, Fahrräder. Monetarisiere.",
      es: "Late check-out, desayuno, traslado, bicis. Rentabiliza.",
    },
  },
  {
    key: "contatti",
    color: "#22C55E",
    title: { it: "Contatti diretti", en: "Direct Contacts", fr: "Contacts directs", de: "Direkte Kontakte", es: "Contactos directos" },
    desc: {
      it: "Telefono, email, WhatsApp 1-click. No filtri OTA.",
      en: "Phone, email, WhatsApp 1-click. No OTA filters.",
      fr: "Téléphone, email, WhatsApp 1-click. Pas de filtres OTA.",
      de: "Telefon, E-Mail, WhatsApp 1-Klick. Keine OTA-Filter.",
      es: "Teléfono, email, WhatsApp 1-click. Sin filtros OTA.",
    },
  },
  {
    key: "chat",
    color: "#06B6D4",
    title: { it: "Chat Host-Ospite", en: "Host-Guest Chat", fr: "Chat Hôte-Voyageur", de: "Host-Gast-Chat", es: "Chat Host-Huésped" },
    desc: {
      it: "Messaggistica diretta con indicatore online real-time.",
      en: "Direct messaging with real-time online indicator.",
      fr: "Messagerie directe avec indicateur en ligne temps réel.",
      de: "Direktnachrichten mit Echtzeit-Online-Indikator.",
      es: "Mensajería directa con indicador online en tiempo real.",
    },
  },
  {
    key: "fedelta",
    color: "#d04260",
    title: { it: "Carta Fedeltà", en: "Loyalty Card", fr: "Carte Fidélité", de: "Treuekarte", es: "Tarjeta Fidelidad" },
    desc: {
      it: "Punti per soggiorno, premi personalizzabili.",
      en: "Points per stay, customizable rewards.",
      fr: "Points par séjour, récompenses personnalisables.",
      de: "Punkte pro Aufenthalt, anpassbare Prämien.",
      es: "Puntos por estancia, premios personalizables.",
    },
  },
  {
    key: "lingue",
    color: "#06B6D4",
    title: { it: "5 lingue auto", en: "5 auto languages", fr: "5 langues auto", de: "5 Sprachen auto", es: "5 idiomas auto" },
    desc: {
      it: "IT · EN · FR · ES · DE. Rilevamento browser.",
      en: "IT · EN · FR · ES · DE. Browser detection.",
      fr: "IT · EN · FR · ES · DE. Détection navigateur.",
      de: "IT · EN · FR · ES · DE. Browser-Erkennung.",
      es: "IT · EN · FR · ES · DE. Detección del navegador.",
    },
  },
  {
    key: "font_colori",
    color: "#8B5CF6",
    title: { it: "Font & Colori", en: "Fonts & Colors", fr: "Polices & Couleurs", de: "Fonts & Farben", es: "Fuentes y Colores" },
    desc: {
      it: "10 palette + 5 font (Playfair, DM Sans, Space Grotesk...).",
      en: "10 palettes + 5 fonts (Playfair, DM Sans, Space Grotesk...).",
      fr: "10 palettes + 5 polices (Playfair, DM Sans, Space Grotesk...).",
      de: "10 Paletten + 5 Fonts (Playfair, DM Sans, Space Grotesk...).",
      es: "10 paletas + 5 fuentes (Playfair, DM Sans, Space Grotesk...).",
    },
  },
  {
    key: "seo_geo",
    color: "#EF4444",
    title: { it: "SEO + GEO", en: "SEO + GEO", fr: "SEO + GEO", de: "SEO + GEO", es: "SEO + GEO" },
    desc: {
      it: "Meta, schema.org, sitemap, OG image, geo-coords.",
      en: "Meta, schema.org, sitemap, OG image, geo-coords.",
      fr: "Meta, schema.org, sitemap, image OG, géo-coords.",
      de: "Meta, schema.org, Sitemap, OG-Bild, Geo-Koordinaten.",
      es: "Meta, schema.org, sitemap, imagen OG, geo-coords.",
    },
  },
  {
    key: "qr",
    color: "#0F172A",
    title: { it: "QR Code Premium", en: "Premium QR Code", fr: "QR Code Premium", de: "Premium-QR-Code", es: "Código QR Premium" },
    desc: {
      it: "PDF stampabile A4 con logo per la stanza.",
      en: "Printable A4 PDF with logo for the room.",
      fr: "PDF A4 imprimable avec logo pour la chambre.",
      de: "Druckbare A4-PDF mit Logo für das Zimmer.",
      es: "PDF A4 imprimible con logo para la habitación.",
    },
  },
  {
    key: "short_link",
    color: "#F59E0B",
    title: { it: "Short Link", en: "Short Link", fr: "Lien Court", de: "Kurz-Link", es: "Enlace Corto" },
    desc: {
      it: "Link personalizzato /s/villa-marco. Facile da ricordare.",
      en: "Custom link /s/villa-marco. Easy to remember.",
      fr: "Lien perso /s/villa-marco. Facile à retenir.",
      de: "Custom Link /s/villa-marco. Leicht zu merken.",
      es: "Enlace personalizado /s/villa-marco. Fácil de recordar.",
    },
  },
  {
    key: "cin",
    color: "#64748B",
    title: { it: "CIN & Compliance", en: "CIN & Compliance", fr: "CIN & Conformité", de: "CIN & Compliance", es: "CIN y Cumplimiento" },
    desc: {
      it: "Codice CIN visibile in footer per la normativa italiana.",
      en: "CIN code visible in footer for Italian regulation.",
      fr: "Code CIN visible en footer pour la norme italienne.",
      de: "CIN-Code im Footer sichtbar für italienische Vorschriften.",
      es: "Código CIN visible en footer para la normativa italiana.",
    },
  },
  {
    key: "analytics",
    color: "#F97316",
    title: { it: "Analytics Live", en: "Live Analytics", fr: "Analytics Live", de: "Live-Analytics", es: "Analítica Live" },
    desc: {
      it: "Visualizzazioni, scansioni QR, click OTA in dashboard.",
      en: "Views, QR scans, OTA clicks in dashboard.",
      fr: "Vues, scans QR, clics OTA dans le dashboard.",
      de: "Aufrufe, QR-Scans, OTA-Klicks im Dashboard.",
      es: "Vistas, escaneos QR, clics OTA en el panel.",
    },
  },
  {
    key: "autosave",
    color: "#10B981",
    title: { it: "Autosalvataggio", en: "Autosave", fr: "Enregistrement auto", de: "Auto-Speichern", es: "Autoguardado" },
    desc: {
      it: "Ogni modifica salvata in tempo reale. Zero perdite.",
      en: "Every change saved in real time. Zero loss.",
      fr: "Chaque modification enregistrée en temps réel. Zéro perte.",
      de: "Jede Änderung in Echtzeit gespeichert. Kein Verlust.",
      es: "Cada cambio guardado en tiempo real. Cero pérdidas.",
    },
  },
];

// ═══════════════════════════════════════════════════════════════
// GUESTAPP — Feature Grid (25 card, incluso GetYourGuide)
// ═══════════════════════════════════════════════════════════════
export const guestAppFeatures = [
  {
    key: "tours",
    color: "#4E9A5A",
    badge: { it: "NEW", en: "NEW", fr: "NEW", de: "NEU", es: "NEW" },
    title: { it: "Tour consigliati", en: "Recommended Tours", fr: "Tours conseillés", de: "Empfohlene Touren", es: "Tours recomendados" },
    desc: {
      it: "Crei tour su misura (a piedi, in bici, in moto, in auto o in barca): l'AI scrive la scheda, mappa e numeri sono reali, tutto tradotto in 5 lingue. Mai visto prima.",
      en: "Create tailor-made tours (on foot, by bike, motorbike, car or boat): the AI writes the content, map and numbers are real, all translated into 5 languages. Never seen before.",
      fr: "Créez des tours sur mesure (à pied, à vélo, à moto, en voiture ou en bateau) : l'IA rédige la fiche, carte et chiffres réels, le tout traduit en 5 langues. Du jamais vu.",
      de: "Erstelle maßgeschneiderte Touren (zu Fuß, mit Rad, Motorrad, Auto oder Boot): Die KI schreibt den Inhalt, Karte und Zahlen sind echt, alles in 5 Sprachen übersetzt. Noch nie dagewesen.",
      es: "Crea tours a medida (a pie, en bici, en moto, en coche o en barco): la IA escribe la ficha, mapa y datos reales, todo traducido a 5 idiomas. Nunca visto.",
    },
  },
  {
    key: "voice",
    color: "#dc2626",
    badge: { it: "NEW", en: "NEW", fr: "NEW", de: "NEU", es: "NEW" },
    title: { it: "Voci della Casa", en: "Voices of the House", fr: "Voix de la Maison", de: "Stimmen des Hauses", es: "Voces de la Casa" },
    desc: {
      it: "Gli ospiti lasciano un messaggio vocale di un minuto: socialità condivisa, moderata da te.",
      en: "Guests leave a one-minute voice message: shared sociability, moderated by you.",
      fr: "Les invités laissent un message vocal d'une minute : convivialité partagée, modérée par vous.",
      de: "Gäste hinterlassen eine einminütige Sprachnachricht: geteilte Geselligkeit, von dir moderiert.",
      es: "Los huéspedes dejan un mensaje de voz de un minuto: socialización compartida, moderada por ti.",
    },
  },
  {
    key: "wifi",
    color: "#2563EB",
    title: { it: "Wi-Fi Magic Card", en: "Wi-Fi Magic Card", fr: "Wi-Fi Magic Card", de: "Wi-Fi Magic Card", es: "Tarjeta Mágica Wi-Fi" },
    desc: {
      it: "Copia password con un tap. Zero domande all'host.",
      en: "Copy password with one tap. Zero questions to the host.",
      fr: "Copiez le mot de passe en un tap. Zéro question à l'hôte.",
      de: "Passwort mit einem Tipp kopieren. Null Fragen an den Host.",
      es: "Copia la contraseña con un toque. Cero preguntas al host.",
    },
  },
  {
    key: "video_welcome",
    color: "#EC4899",
    title: { it: "Video di Benvenuto", en: "Welcome Video", fr: "Vidéo de bienvenue", de: "Willkommensvideo", es: "Vídeo de bienvenida" },
    desc: {
      it: "Presenta la casa con un video personale.",
      en: "Introduce the house with a personal video.",
      fr: "Présentez la maison avec une vidéo personnelle.",
      de: "Stelle das Haus mit einem persönlichen Video vor.",
      es: "Presenta la casa con un vídeo personal.",
    },
  },
  {
    key: "message_welcome",
    color: "#d04260",
    title: { it: "Messaggio Benvenuto", en: "Welcome Message", fr: "Message de bienvenue", de: "Willkommensnachricht", es: "Mensaje de bienvenida" },
    desc: {
      it: "Testo custom dell'host per accogliere ogni ospite.",
      en: "Custom host text to welcome every guest.",
      fr: "Texte personnalisé de l'hôte pour accueillir chaque voyageur.",
      de: "Individueller Text des Hosts, um jeden Gast willkommen zu heißen.",
      es: "Texto custom del host para dar la bienvenida a cada huésped.",
    },
  },
  {
    key: "live_news",
    color: "#EF4444",
    title: { it: "Notizie Live", en: "Live News", fr: "Actus en Direct", de: "Live-News", es: "Noticias Live" },
    desc: {
      it: "Pubblica aggiornamenti live: eventi, orari, alert zona.",
      en: "Publish live updates: events, timetables, area alerts.",
      fr: "Publiez des mises à jour live : événements, horaires, alertes.",
      de: "Veröffentliche Live-Updates: Events, Zeiten, Alerts.",
      es: "Publica actualizaciones en vivo: eventos, horarios, alertas.",
    },
  },
  {
    key: "translations",
    color: "#06B6D4",
    title: { it: "Traduzioni Auto", en: "Auto Translations", fr: "Traductions Auto", de: "Auto-Übersetzungen", es: "Traducciones Auto" },
    desc: {
      it: "IT · EN · FR · ES · DE. Rilevate dal browser ospite.",
      en: "IT · EN · FR · ES · DE. Detected from guest browser.",
      fr: "IT · EN · FR · ES · DE. Détectées depuis le navigateur.",
      de: "IT · EN · FR · ES · DE. Vom Gast-Browser erkannt.",
      es: "IT · EN · FR · ES · DE. Detectados por el navegador.",
    },
  },
  {
    key: "concierge",
    color: "#10B981",
    title: { it: "Local Concierge", en: "Local Concierge", fr: "Concierge Local", de: "Lokaler Concierge", es: "Concierge Local" },
    desc: {
      it: "Ristoranti, pizzerie, pasticcerie, spiagge — foto Google + sconti.",
      en: "Restaurants, pizzerias, bakeries, beaches — Google photos + discounts.",
      fr: "Restaurants, pizzerias, pâtisseries, plages — photos Google + réductions.",
      de: "Restaurants, Pizzerien, Bäckereien, Strände — Google-Fotos + Rabatte.",
      es: "Restaurantes, pizzerías, pastelerías, playas — fotos Google + descuentos.",
    },
  },
  {
    key: "sconti",
    color: "#FF385C",
    badge: { it: "NEW", en: "NEW", fr: "NEW", de: "NEU", es: "NEW" },
    title: { it: "Sconti & Promo", en: "Discounts & Deals", fr: "Réductions & Promos", de: "Rabatte & Deals", es: "Descuentos y Ofertas" },
    desc: {
      it: "Sconti locali dell'host + promo partner Hostland, tutte in un posto.",
      en: "Host's local discounts + Hostland partner deals, all in one place.",
      fr: "Réductions locales de l'hôte + offres partenaires Hostland, au même endroit.",
      de: "Lokale Rabatte des Hosts + Hostland-Partnerangebote, alles an einem Ort.",
      es: "Descuentos locales del host + ofertas de socios Hostland, todo en un lugar.",
    },
  },
  {
    key: "weather",
    color: "#F59E0B",
    title: { it: "Meteo Live 7gg", en: "Live Weather 7d", fr: "Météo Live 7j", de: "Live-Wetter 7 Tage", es: "Tiempo Live 7d" },
    desc: {
      it: "Previsioni della città, già tradotte.",
      en: "City forecast, already translated.",
      fr: "Prévisions de la ville, déjà traduites.",
      de: "Stadtvorhersage, bereits übersetzt.",
      es: "Previsiones de la ciudad, ya traducidas.",
    },
  },
  {
    key: "manuals",
    color: "#A855F7",
    title: { it: "Manuali Casa", en: "House Manuals", fr: "Manuels Maison", de: "Haushaltsanleitungen", es: "Manuales Casa" },
    desc: {
      it: "Riscaldamento, TV, lavatrice, cucina. Foto + FAQ.",
      en: "Heating, TV, washing machine, kitchen. Photos + FAQ.",
      fr: "Chauffage, TV, machine à laver, cuisine. Photos + FAQ.",
      de: "Heizung, TV, Waschmaschine, Küche. Fotos + FAQ.",
      es: "Calefacción, TV, lavadora, cocina. Fotos + FAQ.",
    },
  },
  {
    key: "extras",
    color: "#EC4899",
    title: { it: "Servizi Extra", en: "Extra Services", fr: "Services Extras", de: "Extra-Services", es: "Servicios Extra" },
    desc: {
      it: "Late check-out, colazione, transfer. Monetizza.",
      en: "Late check-out, breakfast, transfer. Monetize.",
      fr: "Late check-out, petit-dej, transfert. Monétisez.",
      de: "Late Check-out, Frühstück, Transfer. Monetarisiere.",
      es: "Late check-out, desayuno, traslado. Rentabiliza.",
    },
  },
  {
    key: "getyourguide",
    color: "#F97316",
    title: { it: "GetYourGuide", en: "GetYourGuide", fr: "GetYourGuide", de: "GetYourGuide", es: "GetYourGuide" },
    desc: {
      it: "Esperienze e tour di GetYourGuide direttamente nella GuestApp.",
      en: "GetYourGuide experiences and tours directly in the GuestApp.",
      fr: "Expériences et tours GetYourGuide directement dans la GuestApp.",
      de: "GetYourGuide-Erlebnisse und Touren direkt in der GuestApp.",
      es: "Experiencias y tours de GetYourGuide directamente en la GuestApp.",
    },
  },
  {
    key: "tour_guide",
    color: "#8B5CF6",
    title: { it: "Guida Turistica", en: "Tour Guide", fr: "Guide Touristique", de: "Reiseführer", es: "Guía Turística" },
    desc: {
      it: "Escursioni, tour, esperienze locali suggerite.",
      en: "Excursions, tours, suggested local experiences.",
      fr: "Excursions, tours, expériences locales suggérées.",
      de: "Ausflüge, Touren, empfohlene lokale Erlebnisse.",
      es: "Excursiones, tours, experiencias locales sugeridas.",
    },
  },
  {
    key: "sitters",
    color: "#F59E0B",
    title: { it: "Baby & Dog Sitter", en: "Baby & Dog Sitter", fr: "Baby & Dog Sitter", de: "Baby & Dog Sitter", es: "Baby y Dog Sitter" },
    desc: {
      it: "Contatti locali di fiducia già pronti nella app.",
      en: "Trusted local contacts already in the app.",
      fr: "Contacts locaux de confiance déjà dans l'app.",
      de: "Vertrauenswürdige lokale Kontakte bereits in der App.",
      es: "Contactos locales de confianza ya listos en la app.",
    },
  },
  {
    key: "rentals",
    color: "#2563EB",
    title: { it: "Noleggi", en: "Rentals", fr: "Locations", de: "Vermietungen", es: "Alquileres" },
    desc: {
      it: "Auto, bici, motorini, sci — con prezzi e contatti.",
      en: "Cars, bikes, scooters, skis — with prices and contacts.",
      fr: "Voitures, vélos, scooters, skis — avec prix et contacts.",
      de: "Autos, Fahrräder, Roller, Ski — mit Preisen und Kontakten.",
      es: "Coches, bicis, motos, esquís — con precios y contactos.",
    },
  },
  {
    key: "parking",
    color: "#0EA5E9",
    title: { it: "Parcheggi vicini", en: "Nearby Parking", fr: "Parkings à proximité", de: "Parken in der Nähe", es: "Aparcamientos cercanos" },
    desc: {
      it: "Dove parcheggiare con costi e mappa.",
      en: "Where to park with costs and map.",
      fr: "Où se garer avec coûts et carte.",
      de: "Wo parken mit Kosten und Karte.",
      es: "Dónde aparcar con costos y mapa.",
    },
  },
  {
    key: "transport",
    color: "#059669",
    title: { it: "Mezzi Pubblici", en: "Public Transport", fr: "Transports Publics", de: "Öffentliche Verkehrsmittel", es: "Transporte Público" },
    desc: {
      it: "Bus, metro, treno — fermate e orari a portata.",
      en: "Bus, metro, train — stops and schedules at hand.",
      fr: "Bus, métro, train — arrêts et horaires à portée.",
      de: "Bus, Metro, Zug — Haltestellen und Fahrpläne griffbereit.",
      es: "Autobús, metro, tren — paradas y horarios a mano.",
    },
  },
  {
    key: "checkin",
    color: "#22C55E",
    title: { it: "Self Check-in", en: "Self Check-in", fr: "Self Check-in", de: "Self-Check-in", es: "Self Check-in" },
    desc: {
      it: "Smart lock, keybox, video istruzioni.",
      en: "Smart lock, keybox, video instructions.",
      fr: "Serrure intelligente, keybox, instructions vidéo.",
      de: "Smart Lock, Keybox, Videoanleitungen.",
      es: "Cerradura inteligente, keybox, instrucciones en vídeo.",
    },
  },
  {
    key: "waste",
    color: "#84CC16",
    title: { it: "Raccolta Rifiuti", en: "Waste Collection", fr: "Collecte des déchets", de: "Müllabfuhr", es: "Recogida de Basuras" },
    desc: {
      it: "Calendario per zona. Niente più multe.",
      en: "Zone calendar. No more fines.",
      fr: "Calendrier par zone. Plus d'amendes.",
      de: "Kalender nach Zone. Keine Bußgelder mehr.",
      es: "Calendario por zona. Sin más multas.",
    },
  },
  {
    key: "rules",
    color: "#F97316",
    title: { it: "Regole Casa", en: "House Rules", fr: "Règles Maison", de: "Hausregeln", es: "Reglas de la Casa" },
    desc: {
      it: "Orari silenzio, tassa soggiorno, chiavi, serratura.",
      en: "Quiet hours, tourist tax, keys, lock.",
      fr: "Heures de silence, taxe de séjour, clés, serrure.",
      de: "Ruhezeiten, Kurtaxe, Schlüssel, Schloss.",
      es: "Horas de silencio, tasa turística, llaves, cerradura.",
    },
  },
  {
    key: "numbers",
    color: "#0EA5E9",
    title: { it: "Numeri Utili", en: "Useful Numbers", fr: "Numéros Utiles", de: "Nützliche Nummern", es: "Números Útiles" },
    desc: {
      it: "Farmacia, meccanico, gommista, supermercato.",
      en: "Pharmacy, mechanic, tire shop, supermarket.",
      fr: "Pharmacie, mécanicien, pneumaticien, supermarché.",
      de: "Apotheke, Mechaniker, Reifenhändler, Supermarkt.",
      es: "Farmacia, mecánico, gomería, supermercado.",
    },
  },
  {
    key: "sos",
    color: "#d04260",
    title: { it: "SOS Emergenze", en: "SOS Emergencies", fr: "SOS Urgences", de: "SOS-Notfälle", es: "SOS Emergencias" },
    desc: {
      it: "112, 118, 115. Pulsante rosso sempre visibile.",
      en: "112, 118, 115. Red button always visible.",
      fr: "112, 118, 115. Bouton rouge toujours visible.",
      de: "112, 118, 115. Roter Knopf immer sichtbar.",
      es: "112, 118, 115. Botón rojo siempre visible.",
    },
  },
  {
    key: "favorites",
    color: "#F43F5E",
    title: { it: "Preferiti", en: "Favorites", fr: "Favoris", de: "Favoriten", es: "Favoritos" },
    desc: {
      it: "L'ospite salva i posti che ama e li ritrova al ritorno.",
      en: "The guest saves loved places and finds them on return.",
      fr: "Le voyageur enregistre ses lieux préférés et les retrouve au retour.",
      de: "Der Gast speichert Lieblingsorte und findet sie beim nächsten Besuch.",
      es: "El huésped guarda los lugares favoritos y los reencuentra al volver.",
    },
  },
  {
    key: "google_review",
    color: "#F59E0B",
    title: { it: "Recensione Google", en: "Google Review", fr: "Avis Google", de: "Google-Bewertung", es: "Reseña Google" },
    desc: {
      it: "Push diretto su Google con 1 click a fine soggiorno.",
      en: "Direct Google push with 1 click at stay end.",
      fr: "Envoi direct sur Google en 1 clic à la fin du séjour.",
      de: "Direkter Google-Push mit 1 Klick am Ende des Aufenthalts.",
      es: "Envío directo a Google con 1 clic al final de la estancia.",
    },
  },
  {
    key: "qr_link",
    color: "#0F172A",
    title: { it: "QR + Short Link", en: "QR + Short Link", fr: "QR + Lien Court", de: "QR + Kurz-Link", es: "QR + Enlace Corto" },
    desc: {
      it: "PDF stampabile + link /g/villa-marco personalizzato.",
      en: "Printable PDF + custom /g/villa-marco link.",
      fr: "PDF imprimable + lien /g/villa-marco personnalisé.",
      de: "Druckbare PDF + benutzerdefinierter Link /g/villa-marco.",
      es: "PDF imprimible + enlace personalizado /g/villa-marco.",
    },
  },
  {
    key: "brand",
    color: "#8B5CF6",
    title: { it: "Brand su misura", en: "Custom Brand", fr: "Brand sur mesure", de: "Individuelles Branding", es: "Marca a medida" },
    desc: {
      it: "Logo, colore accento e nome della struttura ovunque.",
      en: "Logo, accent color and property name everywhere.",
      fr: "Logo, couleur d'accent et nom du logement partout.",
      de: "Logo, Akzentfarbe und Unterkunftsname überall.",
      es: "Logo, color de acento y nombre del alojamiento en todas partes.",
    },
  },
  {
    key: "preview",
    color: "#10B981",
    title: { it: "Live Preview", en: "Live Preview", fr: "Aperçu Live", de: "Live-Vorschau", es: "Vista previa Live" },
    desc: {
      it: "Vedi le modifiche in tempo reale mentre le fai.",
      en: "See changes in real time as you make them.",
      fr: "Voyez les modifications en temps réel.",
      de: "Änderungen in Echtzeit sehen, während du sie machst.",
      es: "Ve los cambios en tiempo real mientras los haces.",
    },
  },
];

// ═══════════════════════════════════════════════════════════════
// FAQ — 10 Q&A in 5 lingue
// ═══════════════════════════════════════════════════════════════
export const faqs = [
  {
    q: {
      it: "Posso creare tour su misura per i miei ospiti?",
      en: "Can I create tailor-made tours for my guests?",
      fr: "Puis-je créer des tours sur mesure pour mes voyageurs ?",
      de: "Kann ich maßgeschneiderte Touren für meine Gäste erstellen?",
      es: "¿Puedo crear tours a medida para mis huéspedes?",
    },
    a: {
      it: "Sì, con i Tour consigliati: una funzione mai vista prima. Scegli il mezzo (a piedi, in bici, in moto, in auto o in barca), inserisci partenza e arrivo e Hostland calcola percorso reale, distanza e dislivello su mappa interattiva. L'intelligenza artificiale scrive descrizione, tappe passo-passo, consigli e cosa portare in pochi secondi — e tu modifichi tutto a mano. Ogni tour è tradotto automaticamente in 5 lingue e appare nel Welcome Book con la mappa del percorso.",
      en: "Yes, with Recommended Tours: a feature never seen before. Pick the mode (on foot, by bike, motorbike, car or boat), set start and finish, and Hostland computes the real route, distance and elevation on an interactive map. The AI writes the description, step-by-step stages, tips and what to bring in seconds — and you can edit everything by hand. Every tour is automatically translated into 5 languages and appears in the Welcome Book with the route map.",
      fr: "Oui, avec les Tours conseillés : une fonction inédite. Choisissez le mode (à pied, à vélo, à moto, en voiture ou en bateau), indiquez départ et arrivée, et Hostland calcule l'itinéraire réel, la distance et le dénivelé sur une carte interactive. L'IA rédige la description, les étapes, les conseils et quoi emporter en quelques secondes — et vous modifiez tout à la main. Chaque tour est traduit automatiquement en 5 langues et apparaît dans le Welcome Book avec la carte du parcours.",
      de: "Ja, mit den Empfohlenen Touren: eine noch nie dagewesene Funktion. Wähle das Fortbewegungsmittel (zu Fuß, Rad, Motorrad, Auto oder Boot), gib Start und Ziel an, und Hostland berechnet die echte Route, Distanz und Höhenmeter auf einer interaktiven Karte. Die KI schreibt in Sekunden Beschreibung, Etappen, Tipps und Packliste — und du bearbeitest alles von Hand. Jede Tour wird automatisch in 5 Sprachen übersetzt und erscheint im Welcome Book mit der Streckenkarte.",
      es: "Sí, con los Tours recomendados: una función nunca vista. Elige el medio (a pie, en bici, en moto, en coche o en barco), indica salida y llegada y Hostland calcula la ruta real, la distancia y el desnivel en un mapa interactivo. La IA escribe la descripción, las etapas, los consejos y qué llevar en segundos — y tú lo editas todo a mano. Cada tour se traduce automáticamente a 5 idiomas y aparece en el Welcome Book con el mapa del recorrido.",
    },
  },
  {
    q: {
      it: "Come funzionano le prenotazioni dirette senza commissioni?",
      en: "How do direct bookings with zero commissions work?",
      fr: "Comment fonctionnent les réservations directes sans commissions ?",
      de: "Wie funktionieren Direktbuchungen ohne Provisionen?",
      es: "¿Cómo funcionan las reservas directas sin comisiones?",
    },
    a: {
      it: "Con Hostland ogni struttura ha un sito e un link (Hostlink) da condividere ovunque: link in bio, storie, QR code. Gli ospiti prenotano contattandoti direttamente, senza passare dalle OTA e senza commissioni sul soggiorno.",
      en: "With Hostland every property gets a website and a link (Hostlink) to share anywhere: link in bio, stories, QR code. Guests book by contacting you directly, with no OTA in the middle and no commission on the stay.",
      fr: "Avec Hostland, chaque logement a un site et un lien (Hostlink) à partager partout : lien en bio, stories, QR code. Les voyageurs réservent en vous contactant directement, sans OTA ni commission sur le séjour.",
      de: "Mit Hostland erhält jede Unterkunft eine Website und einen Link (Hostlink) zum Teilen: Link in Bio, Stories, QR-Code. Gäste buchen, indem sie dich direkt kontaktieren – ohne OTA und ohne Provision.",
      es: "Con Hostland cada alojamiento tiene una web y un enlace (Hostlink) para compartir donde quieras: link in bio, historias, código QR. Los huéspedes reservan contactándote directamente, sin OTA y sin comisiones.",
    },
  },
  {
    q: {
      it: "Posso raccogliere i documenti degli ospiti e inviarli ad Alloggiati Web e ROSS 1000?",
      en: "Can I collect guests' documents and send them to Alloggiati Web and ROSS 1000?",
      fr: "Puis-je collecter les documents des voyageurs et les envoyer à Alloggiati Web et ROSS 1000 ?",
      de: "Kann ich die Dokumente der Gäste erfassen und an Alloggiati Web und ROSS 1000 senden?",
      es: "¿Puedo recoger los documentos de los huéspedes y enviarlos a Alloggiati Web y ROSS 1000?",
    },
    a: {
      it: "Sì, con il Pre check-in di Hostland CONTROL. Invii un link all'ospite che registra i propri documenti prima dell'arrivo; Hostland li trasmette automaticamente ad Alloggiati Web (Questura) e a ROSS 1000, con notifiche Telegram a ogni passaggio. I dati sono cifrati e cancellati subito dopo l'invio. Costa 19,90 € l'anno.",
      en: "Yes, with the Pre check-in in Hostland CONTROL. You send the guest a link to register their documents before arrival; Hostland forwards them automatically to Alloggiati Web (Italian Police) and ROSS 1000, with Telegram notifications at each step. Data is encrypted and deleted right after sending. It costs €19.90/year.",
      fr: "Oui, avec le Pre check-in de Hostland CONTROL. Vous envoyez au voyageur un lien pour enregistrer ses documents avant l'arrivée ; Hostland les transmet automatiquement à Alloggiati Web (Police) et à ROSS 1000, avec des notifications Telegram à chaque étape. Les données sont chiffrées et supprimées juste après l'envoi. 19,90 €/an.",
      de: "Ja, mit dem Pre-Check-in in Hostland CONTROL. Du sendest dem Gast einen Link, um seine Dokumente vor der Ankunft zu erfassen; Hostland übermittelt sie automatisch an Alloggiati Web (Polizei) und ROSS 1000, mit Telegram-Benachrichtigungen bei jedem Schritt. Die Daten sind verschlüsselt und werden direkt nach dem Senden gelöscht. 19,90 €/Jahr.",
      es: "Sí, con el Pre check-in de Hostland CONTROL. Envías al huésped un enlace para registrar sus documentos antes de la llegada; Hostland los transmite automáticamente a Alloggiati Web (Policía) y a ROSS 1000, con notificaciones de Telegram en cada paso. Los datos están cifrados y se eliminan justo después del envío. 19,90 €/año.",
    },
  },
  {
    q: {
      it: "Quanto costa il Pre check-in di Hostland e come funziona?",
      en: "How much does Hostland's Pre check-in cost and how does it work?",
      fr: "Combien coûte le Pre check-in de Hostland et comment ça marche ?",
      de: "Wie viel kostet der Pre-Check-in von Hostland und wie funktioniert er?",
      es: "¿Cuánto cuesta el Pre check-in de Hostland y cómo funciona?",
    },
    a: {
      it: "Il Pre check-in costa 19,90 € l'anno per account (tutte le tue strutture) e si attiva da Hostland CONTROL. Crei la prenotazione, invii il link all'ospite che registra i documenti dei viaggiatori, e Hostland li trasmette automaticamente ad Alloggiati Web e ROSS 1000. Indirizzo e codici della keybox si sbloccano solo dopo la registrazione.",
      en: "The Pre check-in costs €19.90/year per account (all your properties) and is activated from Hostland CONTROL. You create the booking, send the guest a link to register travellers' documents, and Hostland forwards them automatically to Alloggiati Web and ROSS 1000. Address and keybox codes unlock only after registration.",
      fr: "Le Pre check-in coûte 19,90 €/an par compte (tous vos logements) et s'active depuis Hostland CONTROL. Vous créez la réservation, envoyez au voyageur un lien pour enregistrer ses documents, et Hostland les transmet automatiquement à Alloggiati Web et ROSS 1000. L'adresse et les codes de la keybox se débloquent seulement après l'enregistrement.",
      de: "Der Pre-Check-in kostet 19,90 €/Jahr pro Konto (alle Unterkünfte) und wird in Hostland CONTROL aktiviert. Du erstellst die Buchung, sendest dem Gast einen Link zur Dokumentenerfassung, und Hostland übermittelt sie automatisch an Alloggiati Web und ROSS 1000. Adresse und Keybox-Codes werden erst nach der Registrierung freigeschaltet.",
      es: "El Pre check-in cuesta 19,90 €/año por cuenta (todos tus alojamientos) y se activa desde Hostland CONTROL. Creas la reserva, envías al huésped un enlace para registrar los documentos, y Hostland los transmite automáticamente a Alloggiati Web y ROSS 1000. La dirección y los códigos de la keybox se desbloquean solo tras el registro.",
    },
  },
  {
    q: {
      it: "I dati dei documenti degli ospiti sono al sicuro?",
      en: "Is guests' document data safe?",
      fr: "Les données des documents des voyageurs sont-elles en sécurité ?",
      de: "Sind die Dokumentendaten der Gäste sicher?",
      es: "¿Están seguros los datos de los documentos de los huéspedes?",
    },
    a: {
      it: "Sì. I dati degli ospiti sono cifrati e vengono cancellati automaticamente subito dopo l'invio ad Alloggiati Web e ROSS 1000, al massimo entro poche ore dall'arrivo. Hostland non conserva documenti né immagini: salva solo l'esito dell'invio, nel rispetto del GDPR.",
      en: "Yes. Guest data is encrypted and automatically deleted right after sending to Alloggiati Web and ROSS 1000, at most within a few hours of arrival. Hostland keeps no documents or images: it only stores the sending outcome, in compliance with GDPR.",
      fr: "Oui. Les données des voyageurs sont chiffrées et supprimées automatiquement juste après l'envoi à Alloggiati Web et ROSS 1000, au plus tard quelques heures après l'arrivée. Hostland ne conserve ni documents ni images : seul le résultat de l'envoi est enregistré, conformément au RGPD.",
      de: "Ja. Die Gästedaten werden verschlüsselt und direkt nach dem Senden an Alloggiati Web und ROSS 1000 automatisch gelöscht, spätestens wenige Stunden nach der Ankunft. Hostland speichert keine Dokumente oder Bilder: nur das Sendeergebnis, DSGVO-konform.",
      es: "Sí. Los datos de los huéspedes están cifrados y se eliminan automáticamente justo después del envío a Alloggiati Web y ROSS 1000, como máximo pocas horas tras la llegada. Hostland no conserva documentos ni imágenes: solo guarda el resultado del envío, conforme al RGPD.",
    },
  },
  {
    q: {
      it: "Cos'è l'Hostlink?",
      en: "What is the Hostlink?",
      fr: "Qu'est-ce que l'Hostlink ?",
      de: "Was ist der Hostlink?",
      es: "¿Qué es el Hostlink?",
    },
    a: {
      it: "È il link della tua struttura, il punto di partenza per costruire la tua rete. Lo usi nel link in bio dei social, nelle storie, nei post e insieme al QR code sui biglietti da visita: un solo indirizzo che porta ospiti al tuo sito e al Welcome Book.",
      en: "It's your property's link, the starting point to build your network. Use it in your social link in bio, in stories, in posts and together with a QR code on business cards: one address that brings guests to your site and Welcome Book.",
      fr: "C'est le lien de votre logement, le point de départ pour créer votre réseau. Utilisez-le dans le lien en bio, les stories, les posts et avec un QR code sur vos cartes de visite : une seule adresse vers votre site et votre Welcome Book.",
      de: "Es ist der Link deiner Unterkunft – der Startpunkt für dein Netzwerk. Nutze ihn im Social-Link-in-Bio, in Stories, Posts und mit QR-Code auf Visitenkarten: eine Adresse zu deiner Website und deinem Welcome Book.",
      es: "Es el enlace de tu alojamiento, el punto de partida para crear tu red. Úsalo en el link in bio, en historias, en posts y junto al código QR en tarjetas de visita: una sola dirección a tu web y tu Welcome Book.",
    },
  },
  {
    q: {
      it: "Cos'è il Welcome Book digitale?",
      en: "What is the digital Welcome Book?",
      fr: "Qu'est-ce que le Welcome Book numérique ?",
      de: "Was ist das digitale Welcome Book?",
      es: "¿Qué es el Welcome Book digital?",
    },
    a: {
      it: "È il manuale digitale della casa per i tuoi ospiti: check-in, Wi-Fi, regole, elettrodomestici, meteo, mappa e consigli sulla zona. Multilingua e sempre aggiornato, accessibile con un QR code senza scaricare nessuna app.",
      en: "It's the digital house manual for your guests: check-in, Wi-Fi, rules, appliances, weather, map and local tips. Multilingual and always up to date, accessible via a QR code with no app to download.",
      fr: "C'est le manuel numérique du logement pour vos voyageurs : check-in, Wi-Fi, règles, électroménager, météo, carte et conseils locaux. Multilingue et toujours à jour, accessible via un QR code sans appli.",
      de: "Das digitale Haushandbuch für deine Gäste: Check-in, WLAN, Regeln, Geräte, Wetter, Karte und Tipps zur Gegend. Mehrsprachig, immer aktuell, per QR-Code ohne App-Download erreichbar.",
      es: "Es el manual digital de la casa para tus huéspedes: check-in, Wi-Fi, normas, electrodomésticos, tiempo, mapa y consejos de la zona. Multilingüe y siempre actualizado, accesible con un QR sin descargar apps.",
    },
  },
  {
    q: {
      it: "Posso personalizzare lo stile del sito e del Welcome Book?",
      en: "Can I customize the style of the site and Welcome Book?",
      fr: "Puis-je personnaliser le style du site et du Welcome Book ?",
      de: "Kann ich den Stil der Website und des Welcome Books anpassen?",
      es: "¿Puedo personalizar el estilo del sitio y del Welcome Book?",
    },
    a: {
      it: "Sì. Con i temi Stile (Hostland, Minimal, Fluo, Business) cambi palette e font con un clic e vedi l'anteprima in tempo reale. Il look si propaga in modo coerente sul sito della struttura e sul Welcome Book.",
      en: "Yes. With Style themes (Hostland, Minimal, Fluo, Business) you change palette and fonts in one click with a live preview. The look propagates consistently across the property site and the Welcome Book.",
      fr: "Oui. Avec les thèmes Style (Hostland, Minimal, Fluo, Business) vous changez palette et polices en un clic avec un aperçu en direct. Le rendu se propage de façon cohérente sur le site et le Welcome Book.",
      de: "Ja. Mit den Stil-Themes (Hostland, Minimal, Fluo, Business) änderst du Palette und Schriften mit einem Klick inkl. Live-Vorschau. Der Look überträgt sich konsistent auf Website und Welcome Book.",
      es: "Sí. Con los temas de Estilo (Hostland, Minimal, Fluo, Business) cambias paleta y fuentes con un clic y ves la vista previa en tiempo real. El aspecto se propaga de forma coherente en el sitio y el Welcome Book.",
    },
  },
  {
    q: {
      it: "Ogni struttura ha una guida della città?",
      en: "Does each property have a city guide?",
      fr: "Chaque logement a-t-il un guide de la ville ?",
      de: "Hat jede Unterkunft einen Stadtführer?",
      es: "¿Cada alojamiento tiene una guía de la ciudad?",
    },
    a: {
      it: "Sì. La sezione \"Perché visitare\" mostra 10 caratteristiche uniche della città (personaggi celebri, prodotti tipici, curiosità, monumenti) e le domande frequenti, generate automaticamente e tradotte in tutte le lingue: contenuto locale utile agli ospiti e ottimo per l'indicizzazione su Google.",
      en: "Yes. The \"Why visit\" section shows 10 unique city highlights (famous people, local products, curiosities, landmarks) plus FAQs, auto-generated and translated into every language: local content that's useful to guests and great for Google indexing.",
      fr: "Oui. La section « Pourquoi visiter » affiche 10 points uniques sur la ville (personnalités, produits locaux, curiosités, monuments) et une FAQ, générés automatiquement et traduits dans toutes les langues : un contenu local utile et excellent pour le référencement Google.",
      de: "Ja. Der Bereich „Warum besuchen\" zeigt 10 einzigartige Stadt-Highlights (berühmte Personen, lokale Produkte, Kurioses, Sehenswürdigkeiten) plus FAQs – automatisch erstellt und in alle Sprachen übersetzt: lokaler Mehrwert für Gäste und top für die Google-Indexierung.",
      es: "Sí. La sección \"Por qué visitar\" muestra 10 aspectos únicos de la ciudad (personajes célebres, productos típicos, curiosidades, monumentos) y preguntas frecuentes, generados automáticamente y traducidos a todos los idiomas: contenido local útil y excelente para la indexación en Google.",
    },
  },
  {
    q: {
      it: "Cos'è Hostland e a chi serve?",
      en: "What is Hostland and who is it for?",
      fr: "Qu'est-ce que Hostland et à qui s'adresse-t-il ?",
      de: "Was ist Hostland und für wen ist es?",
      es: "¿Qué es Hostland y para quién es?",
    },
    a: {
      it: "Hostland è la piattaforma italiana per host, property manager e viaggiatori. Gli host creano landing page professionali, GuestApp per gli ospiti e QR code personalizzati. I viaggiatori cercano alloggi e contattano direttamente l'host, senza intermediari.",
      en: "Hostland is the Italian platform for hosts, property managers and travelers. Hosts create professional landing pages, GuestApps for guests and custom QR codes. Travelers search stays and contact the host directly, no middlemen.",
      fr: "Hostland est la plateforme italienne pour hôtes, property managers et voyageurs. Les hôtes créent des landing pages pro, GuestApps pour leurs voyageurs et QR codes personnalisés. Les voyageurs cherchent des logements et contactent directement l'hôte, sans intermédiaires.",
      de: "Hostland ist die italienische Plattform für Hosts, Property Manager und Reisende. Hosts erstellen professionelle Landingpages, GuestApps für Gäste und individuelle QR-Codes. Reisende suchen Unterkünfte und kontaktieren den Host direkt, ohne Vermittler.",
      es: "Hostland es la plataforma italiana para hosts, property managers y viajeros. Los hosts crean landing pages profesionales, GuestApps para huéspedes y códigos QR personalizados. Los viajeros buscan alojamiento y contactan directamente al host, sin intermediarios.",
    },
  },
  {
    q: {
      it: "Cos'è la GuestApp?",
      en: "What is the GuestApp?",
      fr: "Qu'est-ce que la GuestApp ?",
      de: "Was ist die GuestApp?",
      es: "¿Qué es la GuestApp?",
    },
    a: {
      it: "Una WebApp esclusiva e privata per i tuoi ospiti. Scansionando il QR in camera accedono a Wi-Fi 1-tap, manuali casa, Local Concierge con foto Google + sconti host, servizi extra a pagamento, esperienze GetYourGuide, calendario raccolta rifiuti e SOS emergenze 112/118/115.",
      en: "An exclusive private WebApp for your guests. Scanning the room QR they access 1-tap Wi-Fi, house manuals, Local Concierge with Google photos + host discounts, paid extras, GetYourGuide experiences, waste calendar and 112/118/115 SOS.",
      fr: "Une WebApp exclusive et privée pour vos voyageurs. En scannant le QR ils accèdent au Wi-Fi 1-tap, manuels maison, Concierge Local avec photos Google + réductions hôte, extras payants, expériences GetYourGuide, calendrier déchets et SOS 112/118/115.",
      de: "Eine exklusive private WebApp für deine Gäste. Beim QR-Scan im Zimmer erhalten sie 1-Tap-WLAN, Hausanleitungen, Local Concierge mit Google-Fotos + Host-Rabatten, kostenpflichtige Extras, GetYourGuide-Erlebnisse, Müllkalender und SOS 112/118/115.",
      es: "Una WebApp exclusiva y privada para tus huéspedes. Escaneando el QR acceden a Wi-Fi 1-toque, manuales casa, Local Concierge con fotos Google + descuentos, extras de pago, experiencias GetYourGuide, calendario basuras y SOS 112/118/115.",
    },
  },
  {
    q: {
      it: "Quanto costa Hostland?",
      en: "How much does Hostland cost?",
      fr: "Combien coûte Hostland ?",
      de: "Wie viel kostet Hostland?",
      es: "¿Cuánto cuesta Hostland?",
    },
    a: {
      it: "Piano Mensile €9,90/mese (2 strutture). Piano Annuale €59,90/anno con strutture illimitate (solo €4,99/mese). 30 giorni di prova gratuita, pagamenti gestiti da Stripe®. ParkHost separato: €4,99/anno dopo il primo mese gratis.",
      en: "Monthly €9.90/month (2 properties). Yearly €59.90/year with unlimited properties (only €4.99/month). 30-day free trial, payments by Stripe®. Separate ParkHost: €4.99/year after first free month.",
      fr: "Mensuel 9,90 €/mois (2 propriétés). Annuel 59,90 €/an avec propriétés illimitées (seulement 4,99 €/mois). 30 jours d'essai gratuit, paiements via Stripe®. ParkHost séparé : 4,99 €/an après le premier mois gratuit.",
      de: "Monatlich 9,90 €/Monat (2 Unterkünfte). Jährlich 59,90 €/Jahr mit unbegrenzten Unterkünften (nur 4,99 €/Monat). 30 Tage kostenlose Testphase, Zahlungen via Stripe®. ParkHost separat: 4,99 €/Jahr nach erstem Gratis-Monat.",
      es: "Mensual 9,90 €/mes (2 alojamientos). Anual 59,90 €/año con alojamientos ilimitados (solo 4,99 €/mes). 30 días de prueba gratis, pagos por Stripe®. ParkHost por separado: 4,99 €/año tras el primer mes gratis.",
    },
  },
  {
    q: {
      it: "Posso trovare alloggi come viaggiatore?",
      en: "Can I find stays as a traveler?",
      fr: "Puis-je trouver des logements en tant que voyageur ?",
      de: "Kann ich als Reisender Unterkünfte finden?",
      es: "¿Puedo encontrar alojamientos como viajero?",
    },
    a: {
      it: "Sì. Nella homepage attiva il toggle 'Viaggiatore' e cerca per comune, ospiti e date. Trovi strutture uniche in Italia con contatto diretto all'host — zero commissioni e prezzi trasparenti.",
      en: "Yes. On the homepage, switch to 'Traveler' and search by city, guests and dates. Find unique Italian stays with direct host contact — zero commissions and transparent prices.",
      fr: "Oui. Sur la homepage, activez le toggle 'Voyageur' et cherchez par ville, voyageurs et dates. Trouvez des logements italiens uniques avec contact direct — zéro commission et prix transparents.",
      de: "Ja. Aktiviere auf der Startseite den 'Reisender'-Toggle und suche nach Stadt, Gästen und Daten. Einzigartige italienische Unterkünfte mit direktem Host-Kontakt — null Provisionen, transparente Preise.",
      es: "Sí. En la homepage activa el toggle 'Viajero' y busca por ciudad, huéspedes y fechas. Encuentra alojamientos únicos con contacto directo al host — cero comisiones y precios transparentes.",
    },
  },
  {
    q: {
      it: "Cos'è la disintermediazione negli affitti brevi?",
      en: "What is disintermediation in short-term rentals?",
      fr: "Qu'est-ce que la désintermédiation en location courte durée ?",
      de: "Was ist Disintermediation bei Kurzzeitvermietungen?",
      es: "¿Qué es la desintermediación en alquileres cortos?",
    },
    a: {
      it: "Significa ricevere prenotazioni dirette senza passare da Airbnb o Booking (che trattengono 15-25% di commissioni). Con Hostland crei sito, QR code e GuestApp per fidelizzare gli ospiti e farli tornare direttamente da te.",
      en: "It means getting direct bookings without going through Airbnb or Booking (who take 15-25% commissions). With Hostland you build website, QR and GuestApp to retain guests and get them to book directly with you.",
      fr: "Cela signifie recevoir des réservations directes sans passer par Airbnb ou Booking (qui prennent 15-25 % de commission). Avec Hostland vous créez site, QR code et GuestApp pour fidéliser vos voyageurs.",
      de: "Es bedeutet, Direktbuchungen zu erhalten ohne Airbnb oder Booking (die 15-25 % Provisionen nehmen). Mit Hostland baust du Website, QR-Code und GuestApp, um Gäste zu binden.",
      es: "Significa recibir reservas directas sin pasar por Airbnb o Booking (que retienen 15-25% de comisiones). Con Hostland creas sitio, QR y GuestApp para fidelizar huéspedes.",
    },
  },
  {
    q: {
      it: "Come funziona il Booking Engine?",
      en: "How does the Booking Engine work?",
      fr: "Comment fonctionne le moteur de résa ?",
      de: "Wie funktioniert die Buchungs-Engine?",
      es: "¿Cómo funciona el motor de reservas?",
    },
    a: {
      it: "Se hai un Channel Manager (Lodgify, Smoobu, Octorate, Guesty, Beds24, Hospitable), incolli l'HTML del widget di prenotazione e appare nella tua landing. Zero commissioni, prenotazione diretta.",
      en: "If you have a Channel Manager (Lodgify, Smoobu, Octorate, Guesty, Beds24, Hospitable), paste the booking widget HTML and it shows in your landing. Zero commissions, direct booking.",
      fr: "Si vous avez un Channel Manager (Lodgify, Smoobu, Octorate, Guesty, Beds24, Hospitable), collez le HTML du widget de résa et il apparaît sur votre landing. Zéro commission, résa directe.",
      de: "Wenn du einen Channel Manager (Lodgify, Smoobu, Octorate, Guesty, Beds24, Hospitable) hast, fügst du das Buchungs-Widget-HTML ein und es erscheint auf deiner Landing. Keine Provisionen, Direktbuchung.",
      es: "Si tienes un Channel Manager (Lodgify, Smoobu, Octorate, Guesty, Beds24, Hospitable), pegas el HTML del widget y aparece en tu landing. Cero comisiones, reserva directa.",
    },
  },
  {
    q: {
      it: "Le recensioni Google si importano automaticamente?",
      en: "Are Google reviews auto-imported?",
      fr: "Les avis Google sont-ils importés automatiquement ?",
      de: "Werden Google-Bewertungen automatisch importiert?",
      es: "¿Las reseñas Google se importan automáticamente?",
    },
    a: {
      it: "Sì. Inserisci l'URL del tuo profilo Google Business, Hostland aggiorna le recensioni ogni 7 giorni con stelle, nome e data.",
      en: "Yes. Add your Google Business profile URL, Hostland updates reviews every 7 days with stars, name and date.",
      fr: "Oui. Ajoutez l'URL de votre profil Google Business, Hostland met à jour les avis tous les 7 jours avec étoiles, nom et date.",
      de: "Ja. Füge deine Google Business-URL hinzu, Hostland aktualisiert die Bewertungen alle 7 Tage mit Sternen, Name und Datum.",
      es: "Sí. Agrega la URL de tu perfil Google Business, Hostland actualiza las reseñas cada 7 días con estrellas, nombre y fecha.",
    },
  },
  {
    q: {
      it: "Hostland è disponibile in altre lingue?",
      en: "Is Hostland available in other languages?",
      fr: "Hostland est-il disponible en d'autres langues ?",
      de: "Ist Hostland in anderen Sprachen verfügbar?",
      es: "¿Hostland está disponible en otros idiomas?",
    },
    a: {
      it: "Sì. Interfaccia in italiano, inglese, francese, spagnolo e tedesco. Le descrizioni delle strutture vengono tradotte automaticamente via AI per gli ospiti internazionali.",
      en: "Yes. Interface in Italian, English, French, Spanish and German. Property descriptions are AI-translated automatically for international guests.",
      fr: "Oui. Interface en italien, anglais, français, espagnol et allemand. Les descriptions sont traduites automatiquement par IA.",
      de: "Ja. Interface auf Italienisch, Englisch, Französisch, Spanisch und Deutsch. Unterkunftsbeschreibungen werden automatisch per KI übersetzt.",
      es: "Sí. Interfaz en italiano, inglés, francés, español y alemán. Las descripciones se traducen automáticamente mediante IA.",
    },
  },
  {
    q: {
      it: "Posso provare gratis?",
      en: "Can I try for free?",
      fr: "Puis-je essayer gratuitement ?",
      de: "Kann ich es kostenlos testen?",
      es: "¿Puedo probarlo gratis?",
    },
    a: {
      it: "Certo. 30 giorni di prova gratuita completa, nessuna carta richiesta. Crei landing, attivi GuestApp, generi QR code — provi tutto senza impegno.",
      en: "Sure. 30 days of full free trial, no card required. Build landing, activate GuestApp, generate QR codes — try it all commitment-free.",
      fr: "Bien sûr. 30 jours d'essai complet gratuit, aucune carte requise. Créez la landing, activez la GuestApp, générez les QR — essayez sans engagement.",
      de: "Klar. 30 Tage volle kostenlose Testphase, keine Karte erforderlich. Landing bauen, GuestApp aktivieren, QR-Codes generieren — alles unverbindlich testen.",
      es: "Claro. 30 días de prueba gratis completa, sin tarjeta. Crea landing, activa GuestApp, genera QR — prueba todo sin compromiso.",
    },
  },
  {
    q: {
      it: "Cos'è ParkHost?",
      en: "What is ParkHost?",
      fr: "Qu'est-ce que ParkHost ?",
      de: "Was ist ParkHost?",
      es: "¿Qué es ParkHost?",
    },
    a: {
      it: "Il modulo per chi ha un posto auto, box, garage o giardino inutilizzato. Crei la pagina del parcheggio, ricevi contatti diretti dagli automobilisti (email/WhatsApp), guadagni senza commissioni. Prima registrazione gratis, poi €4,99/anno.",
      en: "The module for anyone with an unused car spot, box, garage or garden. Create your parking page, get direct contacts from drivers (email/WhatsApp), earn commission-free. First signup free, then €4.99/year.",
      fr: "Le module pour ceux qui ont une place, un box, un garage ou un jardin inutilisé. Créez la page du parking, recevez des contacts directs (email/WhatsApp), gagnez sans commission. Inscription gratuite, puis 4,99 €/an.",
      de: "Das Modul für alle mit einem ungenutzten Auto-Stellplatz, Box, Garage oder Garten. Erstelle deine Parkseite, erhalte direkte Kontakte (E-Mail/WhatsApp), verdiene provisionsfrei. Erste Anmeldung gratis, dann 4,99 €/Jahr.",
      es: "El módulo para quien tiene plaza, box, garaje o jardín sin usar. Crea la página del aparcamiento, recibe contactos directos (email/WhatsApp), gana sin comisiones. Primer registro gratis, luego 4,99 €/año.",
    },
  },
];

export const getT = (obj, lang) => (obj && (obj[lang] || obj.it)) || "";
